import { Link } from "gatsby";
import React, { useEffect, Fragment } from "react";
import PropTypes from "prop-types";

const Header = ({ menu, translations = [] }) => {
    let navMenuButton, navMenu;

    const initSmoothScroll = () => {
        if (typeof window !== "undefined") {
            const SmoothScroll = require("smooth-scroll");
            new SmoothScroll('a[href*="#"]', {
                speed: 800,
                speedAsDuration: true,
                topOnEmptyHash: true,
                easing: "easeOutQuart",
            });
            if (
                window.location.href.indexOf("#") ===
                window.location.href.length - 1
            ) {
                window.scrollTo(0, 0);
            }
        }
    };

    const toggleNav = () => {
        navMenu.classList.toggle("nav__menu--active");
        navMenuButton.classList.toggle("nav__menu-button--active");
        document.body.classList.toggle("disable-scroll");
    };

    const closeMenu = () => {
        if (navMenuButton.classList.contains("nav__menu-button--active")) {
            navMenuButton.classList.remove("nav__menu-button--active");
            navMenu.classList.remove("nav__menu--active");
            document.body.classList.remove("disable-scroll");
        }
    };

    useEffect(() => {
        navMenuButton = document.getElementById("nav_menu_button");
        navMenu = document.getElementById("nav_menu");
        initSmoothScroll();
    });

    return (
        <div className="header-wrapper">
            <header className="header container">
                <Link to="/">
                    <img
                        src={require("assets/images/logo.svg")}
                        alt="site logo"
                    />
                </Link>
                <nav className="nav">
                    <ul id="nav_menu" className="nav__menu">
                        {menu.menuItems.map((item, index) => (
                            <li key={index}>
                                <a href={item.url} onClick={closeMenu}>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                        {translations.map((trans, index) => (
                            <Fragment key={trans.key}>
                                {index !== 0 && <li className="nav__sep">|</li>}
                                <li className="nav__lang">
                                    <a href={trans.link} onClick={closeMenu}>
                                        {trans.key.toUpperCase()}
                                    </a>
                                </li>
                            </Fragment>
                        ))}
                    </ul>
                    <button
                        id="nav_menu_button"
                        className="nav__menu-button"
                        aria-label="mobile menu"
                        onClick={toggleNav}
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </nav>
            </header>
        </div>
    );
};

Header.defaultProps = {
    menus: null,
};

Header.propTypes = {
    menus: PropTypes.any,
};

export default Header;
